/**
 * Studievaardigheden (STU) — 21 families, 5 skills
 *
 * Skills: informatie (5), schemas (7), kaartlezen (2), leerstrategieen (4), presenteren (1)
 *
 * Split from taxonomyRegistry.ts in R23.
 *
 * LDG Audit (16 mrt 2026): 3 tier-aanpassingen doorgevoerd:
 * - STU-INTERNET: M7 (tier 9) → B7 (tier 7) — in 2026 basalere vaardigheid dan bibliotheek
 * - STU-BIBLIOTHEEK: B7 (tier 7) → M7 (tier 9) — verbreding naar fysieke bronnen na digitaal
 * - STU-TABEL: E6 (tier 5) → M6 (tier 3) — tabellen lezen is basisvaardigheid groep 5/6
 */

import type { FamilyDefinition } from '../types';
export const STU_FAMILIES: FamilyDefinition[] = [
// 8.1 Skill: informatie (5 families)
{
  familyId: 'STU-ALFABET',
  module: 'Studievaardig',
  skill: 'informatie',
  subSkill: 'info_alfabetiseren',
  tier: 2,
  levelCode: 'B6+',
  description: 'Alfabetiseren'
}, {
  familyId: 'STU-INHOUDSOPGAVE',
  module: 'Studievaardig',
  skill: 'informatie',
  subSkill: 'info_inhoudsopgave',
  tier: 1,
  levelCode: 'B6',
  description: 'Inhoudsopgave gebruiken (basis essentieel)'
}, {
  familyId: 'STU-WOORDENBOEK',
  module: 'Studievaardig',
  skill: 'informatie',
  subSkill: 'info_woordenboek',
  tier: 3,
  levelCode: 'M6',
  description: 'Woordenboek gebruiken (kerndoel)'
}, {
  familyId: 'STU-INTERNET',
  module: 'Studievaardig',
  skill: 'informatie',
  subSkill: 'info_internet',
  tier: 7,
  levelCode: 'B7',
  description: 'Zoeken op internet (digitale basisvaardigheid)'
}, {
  familyId: 'STU-BIBLIOTHEEK',
  module: 'Studievaardig',
  skill: 'informatie',
  subSkill: 'info_bibliotheek',
  tier: 9,
  levelCode: 'M7',
  description: 'Bibliotheek systeem (fysieke bronnen)'
},
// 8.2 Skill: schemas (7 families)
{
  familyId: 'STU-TABEL',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_tabel',
  tier: 3,
  levelCode: 'M6',
  description: 'Tabellen lezen (basisvaardigheid)'
}, {
  familyId: 'STU-GRAFIEK',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_grafiek',
  tier: 7,
  levelCode: 'B7',
  description: 'Grafieken interpreteren'
}, {
  familyId: 'STU-DIAGRAM',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_diagram',
  tier: 7,
  levelCode: 'B7',
  description: 'Diagrammen lezen (kerndoel)'
}, {
  familyId: 'STU-STAAF',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_staafdiagram',
  tier: 8,
  levelCode: 'B7+',
  description: 'Staafdiagram lezen'
}, {
  familyId: 'STU-LIJN',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_lijndiagram',
  tier: 9,
  levelCode: 'M7',
  description: 'Lijndiagram lezen'
}, {
  familyId: 'STU-CIRKEL',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_cirkeldiagram',
  tier: 9,
  levelCode: 'M7',
  description: 'Cirkeldiagram lezen'
}, {
  familyId: 'STU-TIJDLIJN',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_tijdlijn',
  tier: 7,
  levelCode: 'B7',
  description: 'Tijdlijn lezen en interpreteren'
}, {
  familyId: 'STU-FLOWCHART',
  module: 'Studievaardig',
  skill: 'schemas',
  subSkill: 'schema_flowchart',
  tier: 11,
  levelCode: 'E7',
  description: 'Flowchart lezen en interpreteren'
},
// 8.3 Skill: kaartlezen (2 families)
{
  familyId: 'STU-KAART',
  module: 'Studievaardig',
  skill: 'kaartlezen',
  subSkill: 'kaart_legenda_route',
  tier: 9,
  levelCode: 'M7',
  description: 'Kaartlezen (legenda/schaal)'
}, {
  familyId: 'STU-ROUTE',
  module: 'Studievaardig',
  skill: 'kaartlezen',
  subSkill: 'kaart_route_plannen',
  tier: 11,
  levelCode: 'E7',
  description: 'Route plannen op kaart'
},
// 8.4 Skill: leerstrategieen (4 families)
{
  familyId: 'STU-NOTITIES',
  module: 'Studievaardig',
  skill: 'leerstrategieen',
  subSkill: 'leer_notities',
  tier: 9,
  levelCode: 'M7',
  description: 'Notities maken'
}, {
  familyId: 'STU-SAMENVATTEN',
  module: 'Studievaardig',
  skill: 'leerstrategieen',
  subSkill: 'leer_samenvatten',
  tier: 10,
  levelCode: 'M7+',
  description: 'Teksten samenvatten (kerndoel)'
}, {
  familyId: 'STU-MINDMAP',
  module: 'Studievaardig',
  skill: 'leerstrategieen',
  subSkill: 'leer_mindmap',
  tier: 13,
  levelCode: 'B8',
  description: 'Mindmaps maken'
}, {
  familyId: 'STU-PLANNEN',
  module: 'Studievaardig',
  skill: 'leerstrategieen',
  subSkill: 'leer_plannen',
  tier: 11,
  levelCode: 'E7',
  description: 'Werk plannen en organiseren'
},
// 8.5 Skill: presenteren (1 family)
{
  familyId: 'STU-COMBINEER',
  module: 'Studievaardig',
  skill: 'presenteren',
  subSkill: 'info_combineren',
  tier: 9,
  levelCode: 'M7',
  description: 'Informatie uit meerdere bronnen combineren en presenteren'
}];